<template>
  <div
    :style="{ 'z-index': getPopupZindex }"
    :class="{'integration-popup-overlay': true, 'is-visible': isVisible }">
    <div class="integration-popup">
      <h2>{{ $t('integrationPopup.title') }} - {{ title }}</h2>

      <textarea
        v-model="codeToCopy"
        :readonly="true"></textarea>

      <btn
        @click.native="ok"
        type="popup-left">
        <template v-if="codeCopied">{{ $t('common.ui.copied') }}</template>
        <template v-if="!codeCopied">{{ $t('common.ui.copyToClipboard') }}</template>
      </btn>

      <btn
        @click.native="close"
        type="popup-right">
        {{ $t('common.ui.close') }}
      </btn>
    </div>
  </div>
</template>

<script>
import Copy from 'copy-to-clipboard';
import IntegrationCodes from './../config/integration-codes.js';
import PopupZindex from './../mixins/PopupZindex';

export default {
  name: 'integration-popup',
  mixins: [
    PopupZindex
  ],
  data () {
    return {
      isVisible: false,
      title: '',
      type: '',
      codeCopied: false
    };
  },
  computed: {
    codeToCopy () {
      if (!IntegrationCodes[this.type]) {
        return '';
      }

      return IntegrationCodes[this.type].replace('{{ BOOKERO_ID }}', this.$store.state.config.company.bookero_id).replace('{{ BOOKERO_DOMAIN }}', this.$config.pluginServerUrl);
    }
  },
  mounted () {
    this.$bus.$on('integration-popup-display', this.show);
  },
  methods: {
    ok () {
      Copy(this.codeToCopy);
      this.codeCopied = true;
      setTimeout(() => {
        this.codeCopied = false;
      }, 2000);
    },
    show (type) {
      this.isVisible = true;
      this.type = type;
      this.configurePopup(type);
      this.increasePopupZindex();
    },
    close () {
      this.isVisible = false;
      this.removePopupZindex();
    },
    configurePopup (type) {
      switch (type) {
        case 'inline-box-v2':
          this.title = 'Inline Box';
          break;
        case 'sticky-box-v2':
          this.title = 'Sticky Box';
          break;
        case 'weekly-box-v2':
          this.title = 'Weekly Box';
          break;
        case 'monthly-box-v2':
          this.title = 'Monthly Box';
          break;
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('integration-popup-display', this.show);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.integration-popup {
  background: $color-light;
  border-radius: $border-radius-small;
  box-shadow: 0 5px 5px rgba(0, 0, 0, .25);
  left: 50%;
  overflow: hidden;
  padding: 2rem 2rem 6rem 2rem;
  position: fixed;
  top: 50%;
  transform: translateX(-50%) translateY(-33.333333%);
  transition: transform .25s ease-out;
  width: 56rem;
  will-change: transform;

  &-overlay {
    background: rgba(0, 0, 0, .25);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity .25s ease-out;
    width: 100vw;
    will-change: opacity;

    &.is-visible {
      opacity: 1;
      pointer-events: auto;

      .confirm {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  textarea {
    color: $color-text;
    font-family: monospace;
    font-size: 1.6rem;
    height: 280px;
    padding: 1.5rem 2rem;
    width: 100%;
  }

  h2 {
    font-weight: 400;
    margin: 0 0 2rem 0;
  }

  p {
    color: $color-text;
  }
}

@media (max-width: 640px) {
  .integration-popup {
    border-radius: 0;
    height: 100%;
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/IntegrationPopup.vue